import { LinearProgress } from "@mui/material";
import { useNavigation } from "react-router-dom";

/**
 * A thin progress bar across the top of the content area while a navigation is resolving.
 *
 * With a route loader the outgoing page stays mounted until the incoming one has its data, so
 * without an indicator a click would look like nothing happened. This is what makes loaders an
 * improvement on the skeleton rather than a regression.
 *
 * Absolutely positioned so it overlays rather than reflows the content — a bar that takes up
 * space would reintroduce the layout jump the skeletons were added to remove. Routes with no
 * loader resolve immediately and never reach a non-idle state, so nothing shows for them.
 */
const NavigationProgress = () => {
  const navigation = useNavigation();

  if (navigation.state === "idle") return null;

  return (
    <LinearProgress
      aria-label="Loading page"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: (theme) => theme.zIndex.appBar - 1,
      }}
    />
  );
};

export default NavigationProgress;
